import request from '@utils/request';

// /api/official/mobile/job/share

export async function getJobShare(params) {
  const res = await request.post(`/api/official/mobile/job/share`, params);
  return res;
}

// /api/official/mobile/job/getShareInfo
// {
//   # 必填
//   # 1-新官网
//   # 2-社招伯乐
//   # 3-社招官网
//   # 4-校招伯乐
//   # 5-校招官网
//   jobShareType:str
//   # 选填
//   token:str
//   # 选填
//   staffSsoId:str
// }
export async function getShareInfo(params) {
  try {
    if (!params?.token) {
      params = {
        ...params,
        token: null,
      };
    }
    if (!params.staffSsoId) {
      params = {
        ...params,
        staffSsoId: null,
      };
    }
    const res = await request.post(`/api/official/mobile/job/getShareInfo`, params);
    return res;
  } catch (e) {
    return null;
  }
}

// 复制链接生成短链
export async function getShortenLink(params) {
  const res = await request.post(`/api/official/mobile/job/share/link/shorten`, params);
  return res;
}
